import {
  DEFAULT_COLORS,
  PHASE_COLORS
} from './constants.js';
import { arrayFrom, compactArray, filterArray, hasArrayItems } from '../arrays.js';

export function normalizeNodes(nodes, data = {}) {
  const sourceNodes = hasArrayItems(nodes) ? nodes : fallbackNodes(data);

  return sourceNodes.map((node, index) => ({
    id: node.id || `node-${index + 1}`,
    x: Number(node.x) || 150 + (index * 220),
    y: Number(node.y) || (index % 2 === 0 ? 250 : 150),
    label: node.label || `Step ${index + 1}`,
    phase: node.phase || `Step ${index + 1}`,
    desc: node.desc || node.label || '',
    detail: node.detail || '',
    operatorTip: node.operator_tip || node.operatorTip || '',
    color: node.color || phaseColor(node.phase)
  })).filter(node => node.label);
}

export function normalizeConnections(connections, nodes) {
  const explicitConnections = filterArray(connections, connection => connection?.from && connection?.to);
  if (explicitConnections.length > 0) return explicitConnections;

  return nodes.slice(0, -1).map((node, index) => ({
    from: node.id,
    to: nodes[index + 1].id,
    dashed: false
  }));
}

function fallbackNodes(data) {
  const labels = compactArray(
    arrayFrom(data.must_include).map(value => cleanFallbackLabel(value))
  ).slice(0, 5);

  if (labels.length === 0) return [];

  return labels.map((label, index) => ({
    id: `fallback-${index + 1}`,
    x: 150 + (index * 220),
    y: index % 2 === 0 ? 250 : 150,
    label,
    phase: `Step ${index + 1}`,
    desc: label
  }));
}

function cleanFallbackLabel(value) {
  return String(value || '')
    .replace(/^Primary page concept:\s*/i, '')
    .replace(/^Feature signal:\s*/i, '')
    .replace(/^Section emphasis:\s*/i, '')
    .replace(/^Flow step or supporting element:\s*/i, '')
    .replace(/^Related product surface:\s*/i, '')
    .trim();
}

function phaseColor(phase) {
  const key = String(phase || '').toLowerCase();
  return PHASE_COLORS[key] || DEFAULT_COLORS.brand700;
}
